import React from "react";
import { Link } from "react-router-dom";
import { paths } from "../../paths";
import Marquee from "../home/marquee/marquee";
import Reveal from "../common/Reveal";
import Seo from "../seo/Seo";

const RulebookPage = () => {
  const fileId = "18eE2CRNa-IqNOLoSqcrehQs0AtGqRJtz";
  const drivePdfUrl = `https://drive.google.com/file/d/${fileId}/preview`;
  const downloadUrl = `https://drive.google.com/file/d/${fileId}/view?usp=share_link`;

  return (
    <div className="min-h-screen w-full overflow-x-hidden  font-kumbh text-[#131110]">
      <Seo
        title="Rulebook | Spirit '26 IIT Guwahati Annual Sports Fest"
        description="Official guidelines, eligibility criteria, and fair-play policies for all sporting events under Spirit '26, the Annual Sports Fest of IIT Guwahati."
        path={paths.rulebook}
      />
      <div className="px-6 md:px-12 pt-8">
        <Link
          to={paths.home}
          className="group inline-flex items-center gap-2 font-montserrat text-sm font-semibold uppercase tracking-[2px] text-[#65706E] hover:text-[#cc5e15] transition-colors"
        >
          <span className="transition-transform duration-300 group-hover:-translate-x-1">
            ←
          </span>
          Back to Home
        </Link>
      </div>

      {/* ============================= TITLE & MARQUEE ============================= */}
      <section className="relative pt-10 md:pt-14 pb-10 md:pb-12">
        <div className="mb-7">
          <Marquee text="RULEBOOK"  align="center" />
        </div>

        <Reveal className="max-w-[980px] mx-auto px-6 text-center">
          <h1 className="font-barlow font-semibold text-[#131110] tracking-[-2px] leading-[0.94] text-[48px] sm:text-[72px] md:text-[96px]">
            Official Guidelines <br className="hidden sm:block" /> & Regulations
          </h1>
          <p className="mt-7 max-w-[760px] mx-auto font-montserrat text-base md:text-[18px] leading-relaxed text-[#65706E]">
            Please review the standard procedures, eligibility criteria, and fair-play
            policies for all sporting events under Spirit.
          </p>
        </Reveal>
      </section>

      <section className="relative pb-24 md:pb-28 px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-[1100px] mx-auto">
          <div className="mb-5 flex items-center justify-between gap-4">
            <div>
              <p className="font-montserrat text-xs font-semibold uppercase tracking-[0.24em] text-[#cc5e15]">
                A4 Preview
              </p>
              <p className="mt-2 font-montserrat text-sm text-[#65706E]">
                Full-page rulebook view
              </p>
            </div>

            <a
              href={downloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:inline-flex items-center justify-center px-5 py-3 rounded-full bg-[#131110] text-white font-barlow text-sm font-bold tracking-wider uppercase transition-colors duration-300 hover:bg-[#cc5e15]"
            >
              Open in Drive ↗
            </a>
          </div>

          <div className="relative mx-auto w-full max-w-[min(96vw,794px)] aspect-[210/297] select-none">
            <div className="absolute inset-0 bg-[#00a3a6]" />

            <div className="absolute inset-0 translate-x-2 -translate-y-2 sm:translate-x-3 sm:-translate-y-3 bg-[#cc5e15] p-2 sm:p-3 md:p-6">
              <div className="relative h-full w-full overflow-hidden rounded bg-white shadow-inner">
                <iframe
                  src={drivePdfUrl}
                  title="Spirit Rulebook Preview"
                  className="absolute left-1/2 top-1/2 h-[120%] w-[160%] -translate-x-1/2 -translate-y-[47%] border-none sm:h-[118%] sm:w-[148%] md:h-[116%] md:w-[138%]"
                  allow="autoplay"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={100} className="mt-10 text-center sm:hidden">
          <a
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-7 py-4 rounded-full bg-[#131110] text-white font-barlow text-base font-bold tracking-wider uppercase transition-colors duration-300 hover:bg-[#cc5e15]"
          >
            Open in Google Drive ↗
          </a>
        </Reveal>
      </section>
    </div>
  );
};

export default RulebookPage;